import {
  call, put, all, select,
} from 'redux-saga/effects';
import {
  triiderLogin,
  resetPassword,
  checkTokenPassword,
  updatePassword,
  updateUser,
  apiAddPhotoUser,
  getCompaniesByUser,
} from 'services/api/auth';

import { routes } from 'config/routes';
import { push } from 'connected-react-router';
import { getErrorMessage } from 'utils/filters';

import { Creators as AuthCreators, getTriiderUser } from '../ducks/auth';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';


const fileName = 'sagas/auth';

export function* login({ payload: { email, password } }) {
  try {
    const userData = {
      email,
      password,
    };

    yield put(UiCreators.showLoader('AUTH'));

    const user = yield call(triiderLogin, userData);

    yield put(AuthCreators.loginSuccess(user));

    yield localStorage.setItem('triiderUser', JSON.stringify(user));
    yield all([put(UiCreators.hideLoader('AUTH')), put(push(routes.dashboard))]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(UiCreators.hideLoader('AUTH')),
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, { error, method: `${fileName}/login` }),
      ),
    ]);
  }
}

export function* forgotPasswordSendEmail({ payload: { email, resend, isManageUser } }) {
  try {
    yield put(UiCreators.showLoader('RECOVERY_PASSWORD'));
    yield call(resetPassword, email);
    if (resend) {
      yield put(UiCreators.growl('Email reenviado!', growlTypes.GROWL_SUCCESS));
    } else {
      yield put(AuthCreators.setNewPassword(false));
      yield put(AuthCreators.setEmail(email));
      if (!isManageUser) {
        yield put(push(routes.confirmRecovery));
      } else {
        yield put(UiCreators.growl('E-mail de redefinição de senha enviado!', growlTypes.GROWL_SUCCESS));
      }
    }
    yield put(UiCreators.hideLoader('RECOVERY_PASSWORD'));
  } catch (error) {
    console.error(error);
    yield put(UiCreators.hideLoader('RECOVERY_PASSWORD'));
  }
}

export function* forgotPasswordCheckToken({ payload: { email, token } }) {
  try {
    yield put(UiCreators.showLoader('RECOVERY_PASSWORD'));
    const { success } = yield call(checkTokenPassword, email, token);
    yield put(AuthCreators.setTokenValid(success));
    yield put(UiCreators.hideLoader('RECOVERY_PASSWORD'));
  } catch (error) {
    yield put(AuthCreators.setTokenValid(false));
    console.error(error);
  }
}

export function* forgotPasswordUpdatePassword({ payload: { email, token, password } }) {
  try {
    yield put(UiCreators.showLoader('RECOVERY_PASSWORD'));
    yield call(updatePassword, email, token, password);
    yield put(AuthCreators.setNewPassword(true));
    yield put(push(routes.confirmRecovery));
    yield put(UiCreators.hideLoader('RECOVERY_PASSWORD'));
  } catch (error) {
    yield put(UiCreators.hideLoader('RECOVERY_PASSWORD'));
    console.error(error);
  }
}

export function* updateTriiderUser({ payload: { fields } }) {
  const triiderUser = yield select(getTriiderUser);
  const { user } = triiderUser;

  try {
    yield put(UiCreators.showLoader('UPDATE_USER'));

    if (fields.filePhoto) {
      const { data } = yield call(apiAddPhotoUser, fields.filePhoto);
      if (data.success) {
        fields.profile_picture = data.imageUrl;
      }

      delete fields.filePhoto;
    } else if (fields.filePhoto === null) {
      delete fields.filePhoto;
    }
    const data = yield call(updateUser, fields, user.id);
    if (data.success) {
      Object.assign(user, fields);

      const newUser = {
        ...triiderUser,
        user,
      };

      yield put(AuthCreators.loginSuccess(newUser));
      yield put(UiCreators.hideLoader('UPDATE_USER'));
      yield put(UiCreators.growl('Usuário atualizado com sucesso!', growlTypes.GROWL_SUCCESS));
      yield localStorage.setItem('triiderUser', JSON.stringify(newUser));
    }
  } catch (error) {
    yield put(UiCreators.hideLoader('UPDATE_USER'));
    yield put(UiCreators.growl(`Erro: ${getErrorMessage(error)}`, growlTypes.GROWL_ERROR));
    console.error(error);
  }
}

export function* getCompanies({ payload }) {
  try {
    yield put(UiCreators.showLoader('GET_COMPANIES'));
    const companies = yield call(getCompaniesByUser, payload.userId);
    if (companies.success) {
      yield put(AuthCreators.getCompaniesByUserSuccess(companies.result));
    }
    yield put(UiCreators.hideLoader('GET_COMPANIES'));
  } catch (error) {
    yield put(UiCreators.hideLoader('GET_COMPANIES'));
    console.error(error);
  }
}

export function* changeCompanyUser({ payload }) {
  try {
    yield put(UiCreators.showLoader('CHANGE_COMPANY'));
    const triiderUser = yield select(getTriiderUser);
    const newUser = {
      ...triiderUser,
      company: payload.company,
    };
    yield put(AuthCreators.loginSuccess(newUser));
    yield localStorage.setItem('triiderUser', JSON.stringify(newUser));
    yield put(UiCreators.hideLoader('CHANGE_COMPANY'));
    window.location.reload();
  } catch (error) {
    yield put(UiCreators.hideLoader('CHANGE_COMPANY'));
    console.error(error);
  }
}
